import React from 'react'
import { Typography, Divider } from '@material-ui/core'

const TituloPadina = props => {

    return (
        <>
            <Typography variant="h5" gutterBottom>
                {props.titulo}
            </Typography>
            <Typography variant="body2" gutterBottom>
                {props.subtitulo}
            </Typography>
            <Divider style={{marginBottom: '10px'}}/>
        </>
    )
}

export default TituloPadina
